import { AuthenticationServiceInterface } from 'domain/services';
import {
  AuthenticationMeUseCaseInterface,
  AuthenticationLoginUseCaseInterface,
  AuthenticationLogoutUseCaseInterface,
  AuthenticationSendPasswordResetCodeUseCaseInterface,
  AuthenticationPasswordResetVerifyCodeUseCaseInterface,
  AuthenticationChangePasswordUseCaseInterface,
} from 'domain/usecases';

export class AuthenticationService implements AuthenticationServiceInterface {
  constructor(
    private readonly _authenticationMe: AuthenticationMeUseCaseInterface,
    private readonly _authenticationLogin: AuthenticationLoginUseCaseInterface,
    private readonly _authenticationLogout: AuthenticationLogoutUseCaseInterface,
    private readonly _authenticationChangePassword: AuthenticationChangePasswordUseCaseInterface,
    private readonly _authenticationSendPasswordResetCode: AuthenticationSendPasswordResetCodeUseCaseInterface,
    private readonly _authenticationPasswordResetVerifyCode: AuthenticationPasswordResetVerifyCodeUseCaseInterface,
  ) {}

  authenticationLogin(
    params: AuthenticationLoginUseCaseInterface.Params,
  ): Promise<AuthenticationLoginUseCaseInterface.Result> {
    return this._authenticationLogin.execute(params);
  }

  authenticationLogout(
    params: AuthenticationLogoutUseCaseInterface.Params,
  ): Promise<AuthenticationLogoutUseCaseInterface.Result> {
    return this._authenticationLogout.execute(params);
  }

  authenticationMe(): Promise<AuthenticationMeUseCaseInterface.Result> {
    return this._authenticationMe.execute();
  }

  // reset password
  authenticationSendPasswordResetCode(
    params: AuthenticationSendPasswordResetCodeUseCaseInterface.Params,
  ): Promise<AuthenticationSendPasswordResetCodeUseCaseInterface.Result> {
    return this._authenticationSendPasswordResetCode.execute(params);
  }

  // verify code
  authenticationPasswordResetVerifyCode(
    params: AuthenticationPasswordResetVerifyCodeUseCaseInterface.Params,
  ): Promise<AuthenticationPasswordResetVerifyCodeUseCaseInterface.Result> {
    return this._authenticationPasswordResetVerifyCode.execute(params);
  }

  // change password
  authenticationChangePassword(
    params: AuthenticationChangePasswordUseCaseInterface.Params,
  ): Promise<AuthenticationChangePasswordUseCaseInterface.Result> {
    return this._authenticationChangePassword.execute(params);
  }
}
